module.exports = __webpack_public_path__ + "img/e-sports.28962372.jpg";